import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../../actions';
import { showConfirmationModal } from '../../../actions/App';

import {
  APIcreatePage,
  APIdeletePage,
} from '../../../api/Pages';

import { addFlashMessage } from '../../../helpers/FlashMessages';
import { getPageUrl } from '../../../helpers/PageSections';
import { getCurrentURLParams } from '../../../helpers/URLParams';
import { userHasFeature } from '../../../helpers/Features';
import { upgradeModalIfNeeded } from '../../../helpers/UpgradePlan';

import UpgradePlanButton from '../../UpgradePlanButton';
import { getFormattedDate } from '../../../helpers/DateTime';

class AdminPagesListItem extends PureComponent {
  render() {
    const {
      intl,
      page,
      handleDeletePage,
      handleDuplicatePage,
      deletePageFromList,
      location,
      history,
    } = this.props;

    const linkTo = {
      pathname: `/admin/pages/${page.id}/edit`,
      state: {
        goBackToListButton: {
          text: intl.formatMessage({ defaultMessage: 'Back to all Content Portals' }),
          pathname: '/admin/pages',
          search: getCurrentURLParams(location),
        },
      },
    };

    const duplicateHandler = () => {
      const modalParams = {
        className: 'modal-page-create',
        backdrop: 'static',
        duplicateSourcePageName: page.name,
        initialValues: {
          name: intl.formatMessage(
            { defaultMessage: '{pageName} Copy' },
            { pageName: page.name },
          ),
          url: `${page.url || ''}-copy`,
          visibility_mode: page?.options?.visibility_mode
            || (page.login_required === false ? 'public' : 'login_required'),
        },
        onConfirm: draft => APIcreatePage({
          name: draft.name,
          url: draft.url,
          visibility_mode: draft.visibility_mode || 'login_required',
          duplicate_source_page_id: page.id,
        })
          .then((createResponse) => {
            const newPageId = createResponse?.data?.id;

            addFlashMessage({
              type: 'success',
              text: intl.formatMessage({ defaultMessage: 'The page has been duplicated' }),
            });

            history.push(`/admin/pages/${newPageId}/edit`);
            return true;
          })
          .catch((error) => {
            if (!error?.response?.data?.errors?.['page.url']) {
              addFlashMessage({
                type: 'danger',
                text: intl.formatMessage({ defaultMessage: 'Something went wrong! Please try again.' }),
              });
            }

            throw error;
          }),
        onCancel: () => {},
      };

      handleDuplicatePage(modalParams);
    };

    const lockPageFeature = !userHasFeature('custom-pages') && !page?.is_oldest;

    return (
      <tr>
        <th scope="row" className="page-name">
          {lockPageFeature ? (
            <span className="page-name-content">
              {page.name}
              <UpgradePlanButton feature="custom-pages" />
            </span>
          ) : (
            <Link to={linkTo}>
              {page.name}
            </Link>
          )}
        </th>
        <td className="page-url">
          {lockPageFeature ? (
            getPageUrl(page)
          ) : (
            <Link to={getPageUrl(page)}>
              {getPageUrl(page)}
            </Link>
          )}
        </td>
        <td className="page-visibility-mode">
          {page.visibility_mode === 'public' && intl.formatMessage({ defaultMessage: 'Public' })}
          {page.visibility_mode === 'login_required' && intl.formatMessage({ defaultMessage: 'Login required' })}
          {page.visibility_mode === 'homepage' && intl.formatMessage({ defaultMessage: 'Landing page' })}
        </td>
        <td className="page-views-count">
          {page.views_count}
        </td>
        <td className="page-attributes">
          {page.editor_type === 'puck' && (
            <ul>
              {page.require_name && (
                <li className="active">
                  <span id={`share-name-${page.id}`}>
                    <i className="far fa-user" />
                  </span>
                  <UncontrolledTooltip placement="bottom" target={`share-name-${page.id}`}>
                    {intl.formatMessage({ defaultMessage: 'Name required' })}
                  </UncontrolledTooltip>
                </li>
              )}
              {page.require_email && (
                <li className="active">
                  <span id={`share-email-${page.id}`}>
                    <i className="far fa-envelope" />
                  </span>
                  <UncontrolledTooltip placement="bottom" target={`share-email-${page.id}`}>
                    {intl.formatMessage({ defaultMessage: 'Email required' })}
                  </UncontrolledTooltip>
                </li>
              )}
              {page.require_password && (
                <li className="active">
                  <span id={`share-password-${page.id}`}>
                    <i className="far fa-lock" />
                  </span>
                  <UncontrolledTooltip placement="bottom" target={`share-password-${page.id}`}>
                    {intl.formatMessage({ defaultMessage: 'Password required' })}
                  </UncontrolledTooltip>
                </li>
              )}
              {page.expires_at && (
                <li className="active">
                  <span id={`page-expired-${page.id}`}>
                    <i className="far fa-timer" />
                  </span>
                  <UncontrolledTooltip placement="bottom" target={`page-expired-${page.id}`}>
                    {intl.formatMessage({ defaultMessage: 'Expires: {date}' }, { date: getFormattedDate(page.expires_at) })}
                  </UncontrolledTooltip>
                </li>
              )}
            </ul>
          )}
        </td>
        <td className="action-more">
          <UncontrolledDropdown
            disabled={lockPageFeature}
          >
            <DropdownToggle nav className={classnames('options', { disabled: lockPageFeature })}>
              <i className="far fa-ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu
              right
              container="body"
            >
              <Link
                to={getPageUrl(page)}
                target="_blank"
                className="dropdown-item-link"
              >
                <DropdownItem tag="span">
                  <i className="fas fa-eye" />
                  {intl.formatMessage({ defaultMessage: 'View page' })}
                </DropdownItem>
              </Link>
              <Link to={linkTo} className="dropdown-item-link">
                <DropdownItem tag="span">
                  <i className="fas fa-pencil" />
                  {intl.formatMessage({ defaultMessage: 'Edit' })}
                </DropdownItem>
              </Link>
              {page.editor_type === 'puck' && (
                <>
                  <DropdownItem onClick={() => { history.push(`/admin/pages/${page.id}/details`); }}>
                    <i className="fas fa-circle-info" />
                    {intl.formatMessage({ defaultMessage: 'Details' })}
                  </DropdownItem>
                  <DropdownItem
                    onClick={(e) => upgradeModalIfNeeded('custom-pages', () => duplicateHandler(), e)}
                  >
                    <i className="fas fa-copy" />
                    {intl.formatMessage({ defaultMessage: 'Duplicate' })}
                    <UpgradePlanButton
                      feature="custom-pages"
                      simple={true}
                    />
                  </DropdownItem>
                </>
              )}
              <DropdownItem divider />
              <DropdownItem
                onClick={(e) => {
                  e.preventDefault();
                  handleDeletePage(page, deletePageFromList);
                }}
              >
                <i className="fas fa-trash" />
                {intl.formatMessage({ defaultMessage: 'Delete' })}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  handleDuplicatePage: (modalParams) => (
    dispatch(showModal('AdminPageCreateModal', modalParams))
  ),
  handleDeletePage: (page, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: 'Are you sure you want to delete this Content Portal? The page will be permanently removed.',
      }),
      onConfirm: () => (
        APIdeletePage(page.id).then(() => {
          callback(page);
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminPagesListItem.propTypes = {
  intl: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  handleDeletePage: PropTypes.func.isRequired,
  handleDuplicatePage: PropTypes.func.isRequired,
  deletePageFromList: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminPagesListItem)));
